export default "__VITE_ASSET__iyhdoJQG__"